
// src/context/LibraryContext.jsx
import React, { createContext, useState, useContext, useEffect } from 'react';
import { mockReleases, mockTracks, mockContributors } from '../utils/mockData';

const LibraryContext = createContext();

export const useLibrary = () => useContext(LibraryContext);

export const LibraryProvider = ({ children }) => {
  const [releases, setReleases] = useState([]);
  const [tracks, setTracks] = useState([]);
  const [contributors, setContributors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedRelease, setSelectedRelease] = useState(null);

  // Mock fetching data from API
  useEffect(() => {
    // Simulate API call with setTimeout
    setTimeout(() => {
      try {
        // In a real app, you would fetch this data from your API
        setReleases(mockReleases);
        setTracks(mockTracks);
        setContributors(mockContributors);
        setLoading(false);
      } catch (err) {
        setError('Failed to load library data');
        setLoading(false);
      }
    }, 1000);
  }, []);

  const getTracksByReleaseId = (releaseId) => {
    return tracks.filter(track => track.releaseId === releaseId)
      .sort((a, b) => a.trackNumber - b.trackNumber);
  };

  const getContributorsByReleaseId = (releaseId) => {
    return contributors.filter(contributor => contributor.releaseId === releaseId);
  };

  const getLatestReleases = (count = 3) => {
    return [...releases]
      .sort((a, b) => new Date(b.releaseDate) - new Date(a.releaseDate))
      .slice(0, count);
  };

  const value = {
    releases,
    tracks,
    contributors,
    loading,
    error,
    selectedRelease,
    setSelectedRelease,
    getTracksByReleaseId,
    getContributorsByReleaseId,
    getLatestReleases
  };

  return (
    <LibraryContext.Provider value={value}>
      {children}
    </LibraryContext.Provider>
  );
};
